import {HIDE_DETAIL} from './teamRequestCardDetails.constants';

class TeamRequestCardDetailsController {

  constructor($log, $scope) {
    'ngInject';
    this.open = false;

    $scope.$on(HIDE_DETAIL, () => {
      this.open = false;
    });
  }

  isOpen() {
    return this.open === true;
  }

  toggle() {
    this.open = !this.open;
  }

  getCardClass() {
    let classes = [this.request.type];

    if (this.isMobileApp) {
      classes.push('responsiveMobile');
    }

    return classes;
  }

  getRequestDetailContentClasses() {
    return {
      responsiveMobile: this.isMobileApp
    };
  }

}

export default TeamRequestCardDetailsController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsList/teamRequestCard/teamRequestCardDetails/teamRequestCardDetails.controller.js